const IconFacebook = (): JSX.Element => {
  return (
    <>
      <g clipPath="url(#clip0_6697_9058)">
        <mask
          id="mask0_6697_9058"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="-5"
          y="-5"
          width="34"
          height="34"
        >
          <path d="M-4.80078 -4.80005H28.7992V28.7999H-4.80078V-4.80005Z" fill="white" />
        </mask>
        <g mask="url(#mask0_6697_9058)">
          <path
            d="M24 12.0441C24 5.39234 18.6274 0 12 0C5.37259 0 0 5.39234 0 12.0441C0 17.6925 3.87432 22.432 9.10109 23.7335V15.7246H6.62659V12.0441H9.10109V10.4582C9.10109 6.35876 10.9495 4.45868 14.9594 4.45868C15.7196 4.45868 17.0314 4.60827 17.568 4.7579V8.09431C17.2848 8.0644 16.7929 8.04941 16.1817 8.04941C14.214 8.04941 13.4538 8.7975 13.4538 10.7425V12.0441H17.3734L16.7001 15.7246H13.4538V24C19.3955 23.2797 24 18.2019 24 12.0441Z"
            fill="#0866FF"
          />
          <path
            d="M16.7004 15.667L17.3738 12H13.4542V10.7031C13.4542 8.76524 14.2144 8.01995 16.1821 8.01995C16.7933 8.01995 17.2852 8.03483 17.5684 8.06464V4.7405C17.0318 4.59141 15.72 4.44232 14.9598 4.44232C10.9499 4.44232 9.10145 6.33549 9.10145 10.4199V12H6.62695V15.667H9.10145V23.6466C10.0299 23.8769 11.0007 24 12.0004 24C12.4926 24 12.9775 23.9697 13.4542 23.9121V15.667H16.7004Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6697_9058">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </>
  );
};

export default IconFacebook;
